<template>
  <div>
    <section-definition title="Previsão de Quadro Horário" event-update="pesquisar"></section-definition>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Gerenciar Previsão de Quadro Horário</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <modal-inclusao-qh-previsao :id-plano="plano.id" @qhPrevisaoCadastrada="cadastroEfetuado = $event" v-if="plano.id"/>
    </v-toolbar>
    <modal-edicao-qh-previsao @qhPrevisaoCadastrada="cadastroEfetuado = $event"/>
    <v-container fluid>
      <v-form ref="form" class="hidden-sm-and-down">
        <v-layout align-center row fill-height justify-space-between>
          <v-flex xs12 sm6 md2>
            <v-select v-model="filtro.ano" :items="anos" label="Ano" clearable
              @change="aoSelecionarAno"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-select v-model="filtro.numero" :items="numeros" label="Número" clearable
              :disabled="!filtro.ano" @change="aoSelecionarNumero"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field color="primary" label="Data Início" disabled v-model="plano.dataInicio"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field color="primary" label="Data Fim" disabled v-model="plano.dataFim"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4>
            <v-text-field color="primary" label="Descrição" disabled v-model="plano.descricao"></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
      <div class="qh-previsoes-scroll">
        <v-data-table :loading="loading" :headers="headers" :items="previsoes" class="elevation-1"
          hide-actions>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.numeroRegistro }}</td>
            <td>{{ props.item.nome }}</td>
            <td>{{ props.item.funcao }}</td>
            <td class="text-xs-center">{{ props.item.qhDom }}</td>
            <td class="text-xs-center">{{ props.item.qhSeg }}</td>
            <td class="text-xs-center">{{ props.item.qhTer }}</td>
            <td class="text-xs-center">{{ props.item.qhQua }}</td>
            <td class="text-xs-center">{{ props.item.qhQui }}</td>
            <td class="text-xs-center">{{ props.item.qhSex }}</td>
            <td class="text-xs-center">{{ props.item.qhSab }}</td>
            <td class="text-xs-center">{{ props.item.total }}</td>
            <td>
              <v-icon v-if="plano.ativo" title="Editar" medium class="mr-2" @click="editar(props.item)">
                edit
              </v-icon>
              <v-icon v-if="plano.ativo" title="Excluir" medium class="mr-2" @click="excluir(props.item)">
                delete
              </v-icon>
            </td>
          </template>
          <template slot="no-data">
            Nenhuma previsão cadastrada para o plano!
          </template>
        </v-data-table>
      </div>
    </v-container>
  </div>
</template>
<script>
import qhPrevisaoService from "@/service/qh/QhPrevisaoService";
import qhPlanoService from "@/service/qh/QhPlanoService";
import QhPlanoResumo from "@/model/qh/QhPlanoResumo";
import EventBus from "@/utils/EventBus.js";
import ModalInclusaoQhPrevisao from "./ModalInclusaoQhPrevisao";
import ModalEdicaoQhPrevisao from "./ModalEdicaoQhPrevisao";
export default {
  components: {
    ModalInclusaoQhPrevisao,
    ModalEdicaoQhPrevisao
  },
  data() {
    return {
      loading: false,
      cadastroEfetuado: false,
      previsoes: [],
      anos: [],
      numeros: [],
      filtro: {
        ano: null,
        numero: null
      },
      plano: new QhPlanoResumo(),
      headers: [
        { text: "Nr Registro", align: "left", sortable: false, value: "numeroRegistro" },
        { text: "Nome", align: "left", sortable: false, value: "nome" },
        { text: "Função", align: "left", sortable: false, value: "funcao" },
        { text: "Dom", align: "center", sortable: false, value: "qhDom" },
        { text: "Seg", align: "center", sortable: false, value: "qhSeg" },
        { text: "Ter", align: "center", sortable: false, value: "qhTer" },
        { text: "Qua", align: "center", sortable: false, value: "qhQua" },
        { text: "Qui", align: "center", sortable: false, value: "qhQui" },
        { text: "Sex", align: "center", sortable: false, value: "qhSex" },
        { text: "Sab", align: "center", sortable: false, value: "qhSab" },
        { text: "Total", align: "center", sortable: false, value: "total" },
        { text: "Ações", value: "name", sortable: false }
      ]
    };
  },
  watch: {
    cadastroEfetuado(event) {
      if (event) {
        setTimeout(() => {
          this.pesquisar();
          this.cadastroEfetuado = false;
        }, 500);
      }
    }
  },
  created() {
    this.carregarAnos();
  },
  methods: {
    async carregarAnos() {
      // RN001.1: lista apenas anos com planos ATIVOS da instituição.
      const anosAtivos = await qhPlanoService.listarAnos(true);
      this.anos = anosAtivos || [];
    },
    async aoSelecionarAno() {
      this.filtro.numero = null;
      this.plano = new QhPlanoResumo();
      this.previsoes = [];
      if (this.filtro.ano) {
        this.numeros = await qhPlanoService.listarNumeros(this.filtro.ano);
      } else {
        this.numeros = [];
      }
    },
    async aoSelecionarNumero() {
      this.previsoes = [];
      this.plano = new QhPlanoResumo();
      if (!this.filtro.numero) {
        return;
      }
      const paginacao = await qhPlanoService.listarTodos(
        { ano: this.filtro.ano, numero: this.filtro.numero },
        1,
        1
      );
      if (paginacao && paginacao.dados && paginacao.dados.length > 0) {
        this.plano = new QhPlanoResumo(paginacao.dados[0]);
        this.pesquisar();
      }
    },
    async pesquisar() {
      if (!this.plano.id) {
        this.previsoes = [];
        return;
      }
      this.loading = true;
      const linhas = await qhPrevisaoService.listarPorPlano(this.plano.id);
      this.previsoes = linhas || [];
      this.loading = false;
    },
    editar(linha) {
      EventBus.$emit("editaQhPrevisao", linha.id);
    },
    excluir(linha) {
      confirm("Deseja realmente excluir o registro de previsão?") &&
        qhPrevisaoService.excluir(linha).then(retorno => {
          if (retorno) {
            this.pesquisar();
          }
        });
    }
  }
};
</script>
<style scoped>
/* RN/Issue #147: scroll apenas na lista, não na tela toda */
.qh-previsoes-scroll {
  max-height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: auto;
}
</style>
